import type { ModalToken } from "@/modal-manager";
import type { SdkEventInterface } from "@modules/sdk/events/SdkEventInterface";

import { COMMON_SDK_EVENTS } from "../constants";

class ModalClosedSdkEvent implements SdkEventInterface {
    public readonly type = COMMON_SDK_EVENTS.MODAL_CLOSED;
    public readonly modalName: ModalToken;

    constructor(modalName: ModalToken) {
        this.modalName = modalName;
    }
}

export default ModalClosedSdkEvent;
